<sm-model-general-info
  [model]="selectedModel"
  [editable]="!isExample"
  (showModel)="showModel($event)"
  (commentChanged)="commentChanged($event)"
></sm-model-general-info>
